<template>
  <div class="bg-image">

    <div class="container padded bg-danger-lighten-2" style="opacity: 90%; border-radius: 20px; margin-top: 1.74em; margin-bottom: 1.74em;">
      <div v-if="!successReg || !failReg">

      <h2>Register</h2>
      <el-row v-if="!newSystem">
        <el-col :xs="24" :sm="24" :md="12" :lg="16">
          <select-org-category v-model="cat" no-form  />
        </el-col>

        <el-col :xs="24" :sm="12" :md="6" :lg="4">
          <check-box v-if="cat" style="padding-top: 1.528em; margin-left: 1em;" v-model="existing" no-form :disabled="!cat">Existing</check-box>
        </el-col>
        <el-col v-if="!existing && cat" :xs="24" :sm="12" :md="6" :lg="4">
          <org-action class="pad-top" :category="cat" :is-disabled="false" v-model="contact.organisation" @click="allowSelectOrgs = false" />
        </el-col>


      </el-row>

      <p />
      <el-row v-if="cat" :gutter="10" justify="center">

        <el-col v-if="existing" :xs="24" :sm="12" :md="18" :lg="20">
          <div v-if="cat !== 'Landlord'">
            <select-org v-model="contact.organisation" :type="cat" no-form full-object :disabled="!allowSelectOrgs" />
          </div>
          <div v-else>
            <select-landlord v-model="contact.organisation" label="" no-form full-object :disabled="!allowSelectOrgs" />
          </div>

        </el-col>

      </el-row>

      <p />

      <h2 v-if="contact.organisation && contact.organisation.name"><small>{{cat}}:&nbsp;</small>{{contact.organisation.name}}</h2>

      <el-form inline label-width="174px" v-if="contact.organisation && contact.organisation.name">
        <h4>Contact:</h4>
        <el-row>
          <text-input v-model="contact.name" label="Full Name" required />
          <text-input v-model="contact.shortName"  label="Short Name" />
          <text-input v-model="contact.jobTitle" label="Job Title" />

        </el-row>

        <el-row>
          <text-input type="phone" v-model="contact.phone"  label="Phone" />
          <text-input type="email" v-model="contact.email" label="E-mail" required />
        </el-row>

        <el-row :gutter="12">

          <el-col :span="24">
            <text-input label="Login Id" v-model="contact.login" />
          </el-col>

          <el-col :span="24">
            <el-form-item>
               <password-form v-model="contact" toggle />
           </el-form-item>

           <el-alert v-if="!passwordsMatch"
           title="Passwords Don't Match"
           description="Passwords don't or less 7 letters or include login name"
           show-icon
           type="error"
           :closable="false" />

          </el-col>

        </el-row>

        <el-row>

          <el-col :span="12">
            <check-box label="E-mail Upload Alerts" v-model="contact.sendUploadAlerts" />
          </el-col>

          <el-col :span="12">
            <check-box label="E-mail Approval Alerts" v-model="contact.sendApprovalAlerts" />
          </el-col>

        </el-row>

      </el-form>

      <center>
        <el-button type="text" @click="refreshBrowser()">&lt;&lt;&nbsp;Back</el-button>
        &nbsp;
        <el-button
        type="danger" @click="register"
        :disabled="!(contact.name && contact.email && contact.login && passwordsMatch)">
        Register
      </el-button>
    </center>

  </div>
  <div>

    <div v-if="!newSystem && successReg">
      <center>Successful Registration - Wait for System Admin to approve registration</center>
    </div>

  </div>
</div>

</div>

</template>

<script>

import PostMixins from '@/mixins/PostMixins'
import MD5 from 'crypto-js/md5'

import SelectOrgCategory from '@/components/atoms/selects/SelectOrgCategory'

import SelectAuthority from '@/components/atoms/selects/SelectAuthority'
import SelectBackhaulProvider from '@/components/atoms/selects/SelectBackhaulProvider'
import SelectLandlord from '@/components/atoms/selects/SelectLandlord'
import SelectInsurer from '@/components/atoms/selects/SelectInsurer'

import SelectOrg from '@/components/atoms/selects/SelectOrg'
import OrgAction from '@/components/actions/OrgAction'

import PasswordForm from '@/components/login/PasswordForm'

export default {

  mixins: [PostMixins],

  components: {
    SelectAuthority,
    SelectBackhaulProvider,
    SelectLandlord,
    SelectInsurer,
    SelectOrgCategory,
    SelectOrg,
    PasswordForm,
    OrgAction
  },

  props: {

    newSystem: {
      type: Boolean,
      required: true,
  }
},

  watch: {
    orgId: function (oid) {
      this.orgId = oid
      this.contact.organisation_id = oid
      this.contact.organisation = null
    },

    cat: function (c) {
      this.orgId = null
      this.contact.organisation_id = null
      this.contact.organisation = null
      this.cat = c
    }

  },


  computed: {
    passwordsMatch: function () {

      if (this.contact.password &&
        this.contact.c_password &&
        this.contact.password.length >= 7 &&
        !this.contact.password.includes(this.contact.login)) {
        return (this.contact.password === this.contact.c_password)
      }

    return false
    }

  },

  methods: {

    register () {

      if (this.contact.organisation.id && !this.newSystem) {
        this.contact.organisation_id = this.contact.organisation.id
      } else {
        this.contact.organisation_id = this.xolasClient().id
      }

      this.contact.password   = MD5(this.contact.password.trim()).toString()
      this.contact.c_password = MD5(this.contact.c_password.trim()).toString()

      this.saveForm(this, '/register', null, this.contact, 'Register', this.succeed, this.fail)
    },

    succeed (reg) {
      this.successReg = true
      this.failReg = false

      console.log('success', reg)
      this.$alert('Please wait for the System Admin to approve your registration',
                  'Successful Registration',
                  {
                    confirmButtonText: 'OK',
                    callback: action => {
                      this.refreshBrowser()
                }
              })
        },


    fail (data) {
      this.successReg = false
      this.failReg = true
      console.error(data)
      this.$alert('Something went wrong your registration.',
                  'Failed  Registration',
                  {
                    confirmButtonText: 'OK',
                    callback: action => {
                      this.refreshBrowser()
                }
              })
    }
  },


data () {
  return {
    allowSelectOrgs: true,
    existing: true,
    message: null,
    successReg: false,
    failReg: false,
    orgId: (this.newSystem ? this.xolasClient().id : null),
    cat: null,
    contact: {
      enabled: (this.newSystem ? true : false),
      login: null,
      shortName: null,
      defaultView: (this.newSystem ? 'admin' : null),
      name: null,
      password: null,
      c_password: null,
      allowedHost: this.getStore().hostname,
      super: (this.newSystem ? true : false),
      userRole: (this.newSystem ? 'project|maintenance|property|finance|admin' : null),
      organisation: (this.newSystem ? this.xolasClient() : {})
    }
  }
},

mounted () {
  console.log('contact ', this.contact, 'orgId', this.orgId, 'xolasCient', this.xolasClient())
}


}

</script>

<style scoped>

.pad-top {
  padding-top: 1.5em;
  padding-left: 0.5em;
}

.bg-image {

  width: 100%;

  background: url('/static/login/background.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
}



</style>



// WEBPACK FOOTER //
// Register.vue?4f62817b